import type { PropsWithChildren } from 'react'

import './assets/styles/variables.css'
import './styles/index.scss'

import { ChakraProvider } from '@chakra-ui/react'
import '@fontsource/raleway/400.css'
import '@fontsource/raleway/500.css'
import '@fontsource/raleway/600.css'
import '@fontsource/raleway/700.css'
import '@fontsource/raleway/800.css'
import '@fontsource/roboto'
import '@fontsource/roboto-mono/400.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import '@fontsource/roboto/900.css'
import { Layout } from './components/templates/Layout/Layout'
import { ColorModeProvider } from './components/ui/colorMode'
import { Toaster } from './components/ui/toaster'
import { system as theme } from './theme'

export function App({ children }: Readonly<PropsWithChildren>) {
  return (
    <ChakraProvider value={theme}>
      <ColorModeProvider>
        <Layout>{children}</Layout>
        <Toaster />
      </ColorModeProvider>
    </ChakraProvider>
  )
}
